export const FETCH_WATER_MODELS_DATA_REQUEST =
  "FETCH_WATER_MODELS_DATA_REQUEST";
export const FETCH_WATER_MODELS_DATA_SUCCESS =
  "FETCH_WATER_MODELS_DATA_SUCCESS";
export const FETCH_WATER_MODELS_DATA_FAILURE =
  "FETCH_WATER_MODELS_DATA_FAILURE";

export const fetchWaterModelsDataRequest = (thing) => {
  return {
    type: FETCH_WATER_MODELS_DATA_REQUEST,
    payload: thing,
  };
};

export const fetchWaterModelsDataSuccess = (data) => {
  return {
    type: FETCH_WATER_MODELS_DATA_SUCCESS,
    payload: data,
  };
};

export const fetchWaterModelsDataFailure = (error) => {
  return {
    type: FETCH_WATER_MODELS_DATA_FAILURE,
    payload: error,
  };
};
